import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hoikuenErabikata: BlogMetaData = {
  title: '保育園の選び方｜家庭タイプ別の判断基準と見学で見極める5つのポイント',
  description:
    '保育園の選び方で迷ったら、まず「費用・教育・立地」の3軸で家庭の優先順位を決めることが大切。家庭タイプ別の向き・不向き、見学で必ず確認する5つのポイント、モンテッソーリ園の見極め方をモンテ歴20年以上の園長が解説します。',
  thumbnailUrl: '/img/blog-hoikuen-erabikata.webp',
  filePath: buildBlogFilePath('hoikuen-erabikata'),
  category: BLOG_CATEGORY.NURSERY,
};
